// Pop-up "Nova versão disponível" (feature atualizacao): novidades, "Baixar e instalar" /
// "Agora não", progresso do download e aviso de falha.
import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import type { UpdateController } from '../state/updateController';
import { Dialog } from './EditTaskDialog';
import { BeeLogo, Icon } from './Icon';

export function UpdatePrompt({ controller }: { controller: UpdateController }) {
  const { t } = useTranslation();
  const state = useSyncExternalStore(controller.subscribe, controller.get, controller.get);
  if (state.phase === 'idle' || !state.update) return null;
  const busy = state.phase === 'downloading' || state.phase === 'installing';

  return (
    <Dialog labelId="update-title" onClose={() => (busy ? undefined : state.phase === 'error' ? controller.closeError() : controller.later())}>
      <div className="update" data-testid="update-prompt">
        <div className="update__logo">
          <BeeLogo size={40} />
        </div>
        <h2 id="update-title" className="dialog__title">
          {state.phase === 'error' ? t('update.errorTitle') : t('update.title', { version: state.update.version })}
        </h2>

        {state.phase === 'available' && (
          <>
            {state.update.notes && (
              <div className="update__notes">
                <p className="label-caps">{t('update.whatsNew')}</p>
                <p className="update__notes-text">{state.update.notes}</p>
              </div>
            )}
            <div className="dialog__actions">
              <button type="button" className="btn btn--ghost" onClick={() => controller.later()}>
                {t('update.later')}
              </button>
              <button type="button" className="btn btn--primary" onClick={() => void controller.install()}>
                <Icon name="external" size={14} />
                {t('update.install')}
              </button>
            </div>
          </>
        )}

        {busy && (
          <div className="update__progress" role="status">
            <div className="progress__track">
              <div className="progress__fill" style={{ width: `${state.progress ?? 100}%` }} />
            </div>
            <p className="update__status">
              {state.phase === 'installing'
                ? t('update.installing')
                : state.progress === null
                  ? t('update.downloading')
                  : t('update.downloadingPct', { pct: state.progress })}
            </p>
          </div>
        )}

        {state.phase === 'error' && (
          <>
            <p className="dialog__body">{t('update.errorBody')}</p>
            <div className="dialog__actions">
              <button type="button" className="btn btn--primary" onClick={() => controller.closeError()}>
                {t('common.close')}
              </button>
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
}
